module.exports = __webpack_public_path__ + "static/media/card-vps-n8n-mobile-br.d47ee85c.png";